/**
 * i18n bootstrap (Brief 21).
 *
 * Two locales for M5: en (default) + lv (Latvian). Detection order:
 *   1. URL ?lang=…  (override; sticky for a session)
 *   2. localStorage  (user's last choice)
 *   3. navigator.language
 *
 * Strings live in static JSON modules so vite tree-shakes the unused locales.
 * When we add ja / es, prefer the same pattern over a remote-loaded backend
 * until the catalog of strings stabilises.
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en.json'
import lv from './locales/lv.json'

export const SUPPORTED_LANGS = ['en', 'lv'] as const
export type SupportedLang = (typeof SUPPORTED_LANGS)[number]

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      lv: { translation: lv },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'xcrmiq.lang',
      caches: ['localStorage'],
    },
  })

export default i18n
